import React from 'react';
import styled from '@emotion/styled';
import { useLocale } from 'locale';
import { TextLabel } from 'ds/components/typography';
import { colorToAlpha } from 'helpers/insight';

export const CurrentUnitLabelWrapper = styled.div`
  display: inline-block;
  margin: 0 4px;
  ${({ theme }) => theme.media.showAt({ to: 2 }) `
    margin: 0 8px;
  `}
  padding: 2px 4px;
  background: ${({ theme }) => colorToAlpha(theme.colors.insights.nuisances, 0.07)};
  border-radius: ${({ theme }) => theme.borderRadius.tiny};
  color: ${({ theme }) => theme.colors.insights.nuisances};
`;

export const CurrentUnitLabel: React.FC = () => {
  const { t } = useLocale();
  return (
    <CurrentUnitLabelWrapper>
      <TextLabel small caps weight="bold">{t('violationsInsightSummary.currentUnit')}</TextLabel>
    </CurrentUnitLabelWrapper>
  );
};
